import { useEffect } from 'react'
import styled from 'styled-components'

import { ModalWrap } from '../../../components/modal/ModalWrap'
import { Content } from '../../../components/container/Content'
import { ColumnItem } from '../../../components/common'
import { Text } from '../../../components/text'

import { ReactComponent as SuccessIcon } from '../../../assets/gui/signup.svg'

function SuccessSignUpModal({ onDismiss }: { onDismiss: () => void }) {
  useEffect(() => {
    setTimeout(() => {
      onDismiss()
    }, 2000)
  }, [])

  return (
    <ModalWrap>
      <Content>
        <Container>
          <SuccessIcon />
          <Text size={24} weight={600} block={true} $textAlign="center">
            환영합니다!
          </Text>
          <Text size={18} weight={500} block={true} $textAlign="center">
            회원가입이 완료되었습니다.
          </Text>
        </Container>
      </Content>
    </ModalWrap>
  )
}

const Container = styled(ColumnItem)`
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: calc(100vh - 32px);
  > svg {
    margin-bottom: 8px;
  }
`

export default SuccessSignUpModal
